import React from "react";

function RoadSafetyEvaluation() {
  return (
    <div
      style={{
        position: "relative",
        marginTop: "-13%",
        marginBottom: "-32%",
        zIndex: 0,
      }}
    >
      {/* Add inline styles */}
      <iframe
        src="https://lookerstudio.google.com/embed/u/0/reporting/ca68f870-f9e7-47eb-9353-30b060b0d506/page/KTqBD"
        width="100%"
        height="2000"
      ></iframe>
    </div>
  );
}

export default RoadSafetyEvaluation;
